/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Clubs_Invite_TextInputs */

const en_us2_clubs_invite_text = /** @type {(inputs: Clubs_Invite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Join my club "${i?.name}" on MyPocketGym. In Clubs, tap Join with a code and use:`)
};

const pt_br2_clubs_invite_text = /** @type {(inputs: Clubs_Invite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entra no meu clube "${i?.name}" no MyPocketGym. Em Clubes, toque em Entrar com código e use:`)
};

const es_419_clubs_invite_text = /** @type {(inputs: Clubs_Invite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Únete a mi club "${i?.name}" en MyPocketGym. En Clubes, toca Unirme con código y usa:`)
};

const pt_pt2_clubs_invite_text = /** @type {(inputs: Clubs_Invite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entra no meu clube "${i?.name}" na MyPocketGym. Em Clubes, toca em Entrar com código e usa:`)
};

const fr_fr2_clubs_invite_text = /** @type {(inputs: Clubs_Invite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rejoins mon club « ${i?.name} » sur MyPocketGym. Dans Clubs, touche Rejoindre avec un code et utilise :`)
};

const de_de2_clubs_invite_text = /** @type {(inputs: Clubs_Invite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tritt meinem Club "${i?.name}" in MyPocketGym bei. Tippe unter Clubs auf Mit Code beitreten und nutze:`)
};

const it_it2_clubs_invite_text = /** @type {(inputs: Clubs_Invite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entra nel mio club "${i?.name}" su MyPocketGym. In Club, tocca Entra con un codice e usa:`)
};

/**
* | output |
* | --- |
* | "Join my club \"{name}\" on MyPocketGym. In Clubs, tap Join with a code and use:" |
*
* @param {Clubs_Invite_TextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_invite_text = /** @type {((inputs: Clubs_Invite_TextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Invite_TextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_invite_text(inputs)
	if (locale === "es-419") return es_419_clubs_invite_text(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_invite_text(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_invite_text(inputs)
	if (locale === "de-DE") return de_de2_clubs_invite_text(inputs)
	if (locale === "it-IT") return it_it2_clubs_invite_text(inputs)
	return en_us2_clubs_invite_text(inputs)
});
export { clubs_invite_text as "clubs.invite_text" }